import AbsComponent from "../AbsComponent";
import MyCharLayer from "../MyCharLayer";

export default class CharHeader extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
        this.myCharListLayer = new MyCharLayer('MyCharLayer', this.store, this.actions, this.router, '', _l10n);
    }

    setting(_d, _isCompare, _parent){
        _d = _d.data;

        let lang = $('html').attr('lang') || 'ko';
        let config = this.store.getState().config;

        let templ = $(`
            <div class="signature">
                ${(lang==='ko')?`
                <div class="profileimg">
                    <img src="${config.profileImgPath}/game_profile_images/bns/images?gameServerKey=${_d.server_id}&charKey=${_d.id}">
                </div>
                `:``}
                <div class="desc">
                    <span class="${_isCompare? `character-sub-info`: `btn-mycharacter`}">
                        <span class="level">Lv.${_d.level}</span>
                        ${_d.mastery_level>0?`<span class="mastery-faction">${this.l10n.masteryLevel.replace('{n}', _d.mastery_level)}</span>`:``}
                        <span class="name allowed">${_d.name}</span>
                    </span>
                    <span class="server" title="${_d.server_name}">${_d.server_name}</span>
                    ${_d.guild?`<span class="guild" title="${_d.guild.guild_name}">${_d.guild.guild_name}</span>`:``}
                </div>
            </div>
            <div class="emblem">
                <div class="emblem-job" aria-label="${_d.class_name}" data-balloon-pos="down"><img src="${config.staticPath}/img/job/${_d.clazz}.png" class="thumb"></div>
                <div class="emblem-races" aria-label="${_d.race_name}" data-balloon-pos="down"><img src="${config.staticPath}/img/races/${_d.race}.png" class="thumb"></div>
            </div>
        `);

        $(_parent).empty().append(templ);

        templ.find('.btn-mycharacter').on('click', e=>{
            this.myCharListLayer.open(_d.account_id);
        });

    }

} // end of class